import axios from 'axios';


export const axioscrmInstance = axios.create({
  baseURL: " https://live.api.bigfivecrm.com",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    AuthToken: `Bearer b25ib2FyZGluZ2FwaUBiaWdmaXZlY3JtLmNvbTpzZXJpb3VzMjNhJCMkRkQqI0ZBT1NJREYjKCkqI1dIRkEpKFJVKSgjUUpGU0E=`,
  },
});

const KNOWLEDGE_BASE_API = "/api/v2/articles";

export const KnowledgeBaseApi = async (data) => {
  try {
    const response = await axioscrmInstance.post(KNOWLEDGE_BASE_API, data);
    return response.data;
  } catch (error) {
    console.error("Register failed:", error);
    throw error;
  }
};